import { Divider } from '@material-ui/core'

export default Divider
